import {Component, OnInit} from '@angular/core';
import {MatIconButton} from '@angular/material/button';
import {MatDialog} from '@angular/material/dialog';
import {MatIcon} from '@angular/material/icon';
import {MatTooltip} from '@angular/material/tooltip';
import {AddReviewDialogComponent} from '@app/review/add-review-dialog/add-review-dialog.component';
import {ReviewService} from '@app/review/review.service';
import {filter, mergeMap} from 'rxjs/operators';

@Component({
    selector: 'frog-add-review-button',
    imports: [MatIcon, MatIconButton, MatTooltip],
    templateUrl: './add-review-button.component.html',
    styleUrl: './add-review-button.component.scss',
})
export class AddReviewButtonComponent implements OnInit {
    constructor(
        private reviewService: ReviewService,
        private matDialog: MatDialog,
    ) {}

    ngOnInit() {}

    public addReview(): void {
        this.matDialog
            .open(AddReviewDialogComponent, {
                minWidth: '600px',
                maxWidth: '800px',
            })
            .afterClosed()
            .pipe(
                filter((data) => Boolean(data)),
                mergeMap((data) =>
                    this.reviewService.createReview(data.stream, data.name, data.description),
                ),
            )
            .subscribe();
    }
}
